var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    {
      staticClass: "table is-narrow is-fullwidth table-metadatos",
      class: { "is-bordered": _vm.bordered },
    },
    [
      _c("thead", [
        _c("tr", [
          _c("th", { staticClass: "is-400", attrs: { colspan: "2" } }, [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-space-between is-align-items-center",
              },
              [
                _c(
                  "span",
                  { staticClass: "is-size-6 is-500 has-text-primary" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.aspecto.nombre) +
                        "\n          "
                    ),
                    _vm.editMode && !_vm.forceEdit
                      ? _c(
                          "span",
                          { staticClass: "tag is-primary is-rounded ml-3" },
                          [
                            _c(
                              "span",
                              { staticClass: "animated flash infinite slower" },
                              [_vm._v("Editando")]
                            ),
                            _vm._v(" "),
                            _c("button", {
                              staticClass: "delete is-small",
                              on: {
                                click: function ($event) {
                                  _vm.editMode = false
                                },
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-switch",
                  {
                    staticClass: "is-400",
                    attrs: {
                      outlined: true,
                      "left-label": true,
                      rounded: false,
                      size: "is-small",
                    },
                    model: {
                      value: _vm.showDetails,
                      callback: function ($$v) {
                        _vm.showDetails = $$v
                      },
                      expression: "showDetails",
                    },
                  },
                  [_vm._v("Ver detalles")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showDetails
              ? _c("p", { staticClass: "is-size-7" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.aspecto.descripcion) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.atributos, function (atributo, index) {
            return _c("tr", { key: `att-${index}` }, [
              _c("td", [
                _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-justify-content-space-between is-align-items-center",
                  },
                  [
                    _c("p", [
                      _c("b", [_vm._v(_vm._s(atributo.nombre))]),
                      _vm._v(" "),
                      atributo.obligatorio
                        ? _c(
                            "span",
                            { staticClass: "has-text-danger is-size-7 is-300" },
                            [_vm._v("* Requerido")]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "is-size-7 has-text-grey-light" },
                      [
                        _vm._v(
                          "(" +
                            _vm._s(_vm.getNombreAtributo(atributo.tipo)) +
                            ")"
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.showDetails
                  ? _c("p", { staticClass: "help" }, [
                      _c(
                        "span",
                        { class: { "has-text-danger": atributo.obligatorio } },
                        [
                          _vm._v(
                            "(" +
                              _vm._s(
                                atributo.obligatorio ? "Requerido" : "Opcional"
                              ) +
                              ")"
                          ),
                        ]
                      ),
                      _vm._v(" " + _vm._s(atributo.descripcion) + "\n        "),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("td", { class: { editing: _vm.editMode } }, [
                !_vm.editMode
                  ? _c("section", { on: { click: _vm.showEditMode } }, [
                      _vm.getNombreAtributo(atributo.tipo) == "Binario"
                        ? _c("p", {}, [
                            _vm._v(
                              _vm._s(
                                (_vm.metadatos[atributo.id] !== null &&
                                  _vm.getValueBinario(
                                    _vm.metadatos[atributo.id]
                                  )) ||
                                  "-"
                              )
                            ),
                          ])
                        : _vm.getNombreAtributo(atributo.tipo) == "Fecha"
                        ? _c("p", {}, [
                            _vm._v(
                              _vm._s(
                                (_vm.metadatos[atributo.id] !== null &&
                                  _vm.getMomentDate(
                                    _vm.metadatos[atributo.id]
                                  )) ||
                                  "-"
                              )
                            ),
                          ])
                        : _c("p", {}, [
                            _vm._v(_vm._s(_vm.metadatos[atributo.id] || "-")),
                          ]),
                    ])
                  : _c("section", [
                      _vm.isInputText(atributo.tipo)
                        ? _c(
                            "div",
                            { staticClass: "control is-expanded" },
                            [
                              _vm.isNumber(atributo.tipo)
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.inputs[atributo.id],
                                        expression: "inputs[atributo.id]",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.getRules(
                                          atributo.obligatorio,
                                          atributo.tipo
                                        ),
                                        expression:
                                          "getRules(atributo.obligatorio, atributo.tipo)",
                                      },
                                    ],
                                    staticClass: "input",
                                    class: {
                                      "is-danger": _vm.errors.has(atributo.id),
                                    },
                                    attrs: {
                                      type: "text",
                                      name: atributo.id,
                                      placeholder: _vm.getPlaceholderAtributo(
                                        atributo.tipo
                                      ),
                                    },
                                    domProps: {
                                      value: _vm.inputs[atributo.id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.inputs,
                                          atributo.id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm.isDate(atributo.tipo)
                                ? _c(
                                    "b-datepicker",
                                    {
                                      attrs: {
                                        "date-formatter": _vm.dateFormatter,
                                        "first-day-of-week": 1,
                                        "append-to-body": _vm.isOnModal,
                                        "mobile-native": false,
                                        placeholder:
                                          "Haga clic para elegir una fecha",
                                        "trap-focus": "",
                                      },
                                      on: {
                                        input: (date) =>
                                          _vm.updateDateInput(
                                            date,
                                            atributo.id
                                          ),
                                      },
                                      model: {
                                        value: _vm.inputs[atributo.id],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.inputs, atributo.id, $$v)
                                        },
                                        expression: "inputs[atributo.id]",
                                      },
                                    },
                                    [
                                      _c("b-button", {
                                        attrs: {
                                          label: "Borrar fecha",
                                          type: "is-danger is-small is-fullwidth",
                                          "icon-left": "times",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clearDate(atributo.id)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.inputs[atributo.id],
                                        expression: "inputs[atributo.id]",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.getRules(
                                          atributo.obligatorio,
                                          atributo.tipo
                                        ),
                                        expression:
                                          "getRules(atributo.obligatorio, atributo.tipo)",
                                      },
                                    ],
                                    staticClass: "input",
                                    class: {
                                      "is-danger": _vm.errors.has(atributo.id),
                                    },
                                    attrs: {
                                      type: "text",
                                      name: atributo.id,
                                      placeholder: _vm.getPlaceholderAtributo(
                                        atributo.tipo
                                      ),
                                    },
                                    domProps: {
                                      value: _vm.inputs[atributo.id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.inputs,
                                          atributo.id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                              _vm._v(" "),
                              atributo.tipo === "date"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.auxInputs[atributo.id],
                                        expression: "auxInputs[atributo.id]",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.getRules(
                                          atributo.obligatorio,
                                          atributo.tipo
                                        ),
                                        expression:
                                          "getRules(atributo.obligatorio, atributo.tipo)",
                                      },
                                    ],
                                    staticClass: "input",
                                    class: {
                                      "is-danger": _vm.errors.has(
                                        `aux-${atributo.id}`
                                      ),
                                    },
                                    attrs: {
                                      type: "hidden",
                                      name: `aux-${atributo.id}`,
                                      placeholder: _vm.getPlaceholderAtributo(
                                        atributo.tipo
                                      ),
                                    },
                                    domProps: {
                                      value: _vm.auxInputs[atributo.id],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.auxInputs,
                                          atributo.id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has(atributo.id)
                                ? _c("p", { staticClass: "help is-danger" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.first(atributo.id))
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has(`aux-${atributo.id}`)
                                ? _c("p", { staticClass: "help is-danger" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(`aux-${atributo.id}`)
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c("div", { staticClass: "control is-expanded" }, [
                            _c("div", { staticClass: "select is-fullwidth" }, [
                              atributo.tipo == "boolean"
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.inputs[atributo.id],
                                          expression: "inputs[atributo.id]",
                                        },
                                      ],
                                      attrs: { name: atributo.nombre },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.inputs,
                                            atributo.id,
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: true } },
                                        [_vm._v("Si / Verdadero")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: false } },
                                        [_vm._v("No / Falso")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              atributo.tipo == "enum"
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.inputs[atributo.id],
                                          expression: "inputs[atributo.id]",
                                        },
                                      ],
                                      attrs: { name: atributo.nombre },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.inputs,
                                            atributo.id,
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        atributo.parametros.opciones,
                                        function (opcion) {
                                          return _c(
                                            "option",
                                            {
                                              key: opcion,
                                              domProps: { value: opcion },
                                            },
                                            [_vm._v(_vm._s(opcion))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                    ]),
              ]),
            ])
          }),
          _vm._v(" "),
          _vm.editMode && !_vm.hideSaveButton && _vm.canEdit
            ? _c(
                "tr",
                { staticClass: "save-button", on: { click: _vm.submit } },
                [_vm._m(0)]
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "2" } }, [
      _c(
        "button",
        { staticClass: "button is-info is-fullwidth is-small is-radiusless" },
        [_c("i", { staticClass: "fas fa-save" }), _vm._v(" Guardar metadatos")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }